import React, { useState, useEffect, useRef } from "react";
import {
  Table,
  Input,
  Button,
  Space,
  message,
  Typography,
  Tag,
  Modal as ModalB,
} from "antd";
import Highlighter from "react-highlight-words";

//Iconos y constantes
import {
  SearchOutlined,
  MailOutlined,
  ExclamationCircleOutlined,
} from "@ant-design/icons";

//Componentes propios de detalle y actualizacion
import ModalApp from "../../Modal";
import CST from "../../../utils/CustomSettings";
import DetalleCxc from "./DetalleCxc";

//Importaciones para el uso de Redux
import { useSelector } from "react-redux";

//Importaciones y componentes propios
import { showNotification } from "../../../utils/ShowNotification";
import FRM from "../../../utils/FrmService";
import curStyle from "../../../css/GlobalCmp.module.css";
import { myNumber } from "../../../utils/ArrayFunctions";
import { URL_FILES } from "../../../constants";

//Estilos
import "./SalidasAnm.scss";

export default function CuentasxCbr(props) {
  const { setIsLoading, myNumber, tipoSal } = props;
  const [isVisibleModal, setIsVisibleModal] = useState(false);
  const [widthModal, setWidthModal] = useState("70%");
  const [tipoModal, setTipoModal] = useState(1);
  const [detalleModal, setDetalleModal] = useState({});
  const [detalleList, setDetalleList] = useState([]);
  const [totalCxc, setTotalCxc] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);
  const [listSalidas, setListSalidas] = useState([]);
  const [stateCxc, setStateCxc] = useState(Math.random());

  const { confirm } = ModalB;
  const { Title } = Typography;

  //useSelector para acceder al store
  const currentUser = useSelector(
    (state) => state.currentUser.currentUser.user_data
  );

  const currentSetup = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.utlsetup
  );

  const currentMoneda = useSelector(
    (state) => state.rolEnviroment.rolEnviroment.monedas
  );

  useEffect(() => {
    (async () => {
      let datos = await FRM.getGastos(currentUser, tipoSal);
      if (datos.type && datos.type > 0) {
        setListSalidas(datos.listado);
        setTotalCxc(datos.total_rsm);
      } else {
        showNotification(
          "topRight",
          1,
          "CUENTAS POR COBRAR",
          "No hay CUENTAS REGISTRADAS"
        );
      }
    })();
  }, [stateCxc]);

  const openModal = (record, tipo, ancho) => {
    setTipoModal(tipo);
    setWidthModal(ancho);
    setDetalleModal(record);
    setIsVisibleModal(true);
  };

  const closeModal = () => {
    setIsVisibleModal(false);
  };

  const getDetalle = async (record, opcion) => {
    let datos = await FRM.getGastos(currentUser, 25, record.trc_id);
    if (datos.type && datos.type > 0) {
      setDetalleList(datos.listado);
      openModal(record, opcion, "1000px");
    } else {
      showNotification(
        "topRight",
        2,
        "DETALLE SALIDA",
        "No hay Datos registrados"
      );
    }
  };

  const openAdjunto = (record) => {
    //Url para visaulizacion del PDF Temporal
    const url_temp =
      URL_FILES + currentUser.dominio + "/gastos/" + record.meg_adjunto;
    window.open(`${url_temp}`);
  };

  const deleRecord = async (record) => {
    if (record.sal_estado !== 0) {
      showNotification(
        "topRight",
        4,
        "ELIMINAR VENTA",
        "LA VENTA YA FUE FACTURADA"
      );
      return false;
    }

    if (record.sal_tipo !== 1) {
      showNotification(
        "topRight",
        4,
        "ELIMINAR SALIDA",
        "SOLO SE PUEDEN ELIMINAR SALIDAS POR VENTA"
      );
      return false;
    }
    confirm({
      title: "EILIMINAR LA VENTA",
      icon: <ExclamationCircleOutlined />,
      okText: "ELIMINAR",
      cancelText: "Cancelar",
      content: "DESEA ELIMINAR LA VENTA?",
      onOk() {
        deleVenta(record);
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  //Eliminar Ventas
  const deleVenta = async (salida) => {
    setIsLoading(true);
    let record = {
      sal_id: salida.sal_numero,
      usr_id: currentUser.id,
      cmb_id: salida.cmb_org,
      cmp_id: salida.cmp_id,
      sal_cantidad: salida.sal_cantidad,
    };
    var val_gasto = await FRM.sendSalida(currentUser, record, 32);
    if (val_gasto.type && Number.parseInt(val_gasto.type) > 0) {
      setStateCxc(Math.random());
      showNotification("topRight", 4, "ELIMINAR VENTAS", "MOVIMIENTO EXITOSO");
    } else {
      showNotification("topRight", 2, "ELIMINAR VENTAS", val_gasto.message);
    }
    setIsLoading(false);
  };

  //Nuevas funciones de busqueda de columnas
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Search
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Reset
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Filter
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1890ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });
  //Fin de nuevas funciones de busqueda

  //Columnas de la tabla
  const columns = [
    {
      title: "ID",
      key: "action",
      width: "2%",
      render: (text, record) => (
        <Button
          type="primary"
          className={curStyle.btnLila}
          size="large"
          shape="circle"
        >
          {record.trc_id}
        </Button>
      ),
    },
    {
      title: "NOMBRE", //10%
      dataIndex: "trc_nombre",
      key: "trc_nombre",
      ...getColumnSearchProps("trc_nombre"),
    },
    {
      title: "CONTACTO", //10%
      dataIndex: "trc_contacto",
      key: "trc_contacto",
      ...getColumnSearchProps("trc_contacto"),
    },
    {
      title: "E-mail", //10%
      dataIndex: "trc_email",
      key: "trc_email",
      ...getColumnSearchProps("trc_email"),
    },
    {
      title: "SALDO",
      dataIndex: "saldo",
      key: "saldo",
      align: "right",
      render: (text, row, index) => {
        return Number.parseFloat(row.saldo) > 0 ? (
          <Tag color="purple" style={{ fontSize: 15 }}>
            {myNumber(1, row.saldo, 2)}
          </Tag>
        ) : (
          <Tag color="cyan" style={{ fontSize: 15 }}>
            {myNumber(1, row.saldo, 2)}
          </Tag>
        );
      },
    },
    {
      title: "+",
      key: "action",
      width: "2%",
      render: (text, record) => (
        <Button
          type="primary"
          className={curStyle.btnSky}
          size="large"
          shape="circle"
          icon={<SearchOutlined />}
          onClick={() => getDetalle(record, 1)}
        />
      ),
    },
    {
      title: "+",
      key: "action",
      width: "2%",
      render: (text, record) => (
        <Button
          type="primary"
          className={curStyle.btnLila}
          size="large"
          shape="circle"
          icon={<MailOutlined />}
          onClick={() => getDetalle(record, 3)}
        />
      ),
    },
  ];

  //Renderizacion del componente
  return (
    <div className="main-content">
      <Table
        columns={columns}
        dataSource={listSalidas}
        style={{ padding: 3, marginTop: 5 }}
        summary={(pageData) => {
          return (
            <>
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={4}>
                  <Title level={4}>{"TOTAL CUENTA X COBRAR"}</Title>
                </Table.Summary.Cell>
                <Table.Summary.Cell>
                  <Title level={4} style={{ textAlign: "right" }}>
                    {myNumber(1, totalCxc, 2)}
                  </Title>
                </Table.Summary.Cell>
                <Table.Summary.Cell colSpan={2}></Table.Summary.Cell>
              </Table.Summary.Row>
            </>
          );
        }}
      />
      <ModalApp
        isVisibleModal={isVisibleModal}
        closeModal={closeModal}
        widthModal={tipoModal === 4 ? 1307 : widthModal}
      >
        {tipoModal === 1 ? (
          <DetalleCxc
            myNumber={myNumber}
            detalleModal={detalleModal}
            detalleList={detalleList}
          />
        ) : tipoModal === 2 ? (
          <DetalleCxc
            myNumber={myNumber}
            detalleModal={detalleModal}
            detalleList={detalleList}
          />
        ) : (
          <DetalleCxc
            myNumber={myNumber}
            detalleModal={detalleModal}
            detalleList={detalleList}
          />
        )}
      </ModalApp>
    </div>
  );
}
